var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyEmbedCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10005 11.6999C1.67569 11.6999 1.26871 11.5313 0.968644 11.2313C0.668576 10.9312 0.5 10.5243 0.5 10.0999V2.09999C0.5 1.67564 0.668576 1.26868 0.968644 0.968625C1.26871 0.668569 1.67569 0.5 2.10005 0.5H10.1003C10.5247 0.5 10.9317 0.668569 11.2317 0.968625C11.5318 1.26868 11.7004 1.67564 11.7004 2.09999",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9001 5.2998H6.89986C6.01617 5.2998 5.2998 6.01614 5.2998 6.89979V14.8997C5.2998 15.7834 6.01617 16.4997 6.89986 16.4997H14.9001C15.7838 16.4997 16.5002 15.7834 16.5002 14.8997V6.89979C16.5002 6.01614 15.7838 5.2998 14.9001 5.2998Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30003 9.2998L8.5 10.8998L9.30003 12.4998M12.5001 9.2998L13.3002 10.8998L12.5001 12.4998",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyEmbedCode);
export default __webpack_public_path__ + "static/media/copy-embed-code.c69157f8dc2c59a6fe363214dfd1262d.svg";
export { ForwardRef as ReactComponent };